import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { Filter } from 'src/app/Models/InventoryManagement/filter';
import { InventoryData, MaterialDamaged } from 'src/app/Models/InventoryManagement/inventory-data';
import { InventoryService } from 'src/app/Services/InventoryManagement/inventory.service';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { PagerService } from 'src/app/Services/pager.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { identifierModuleUrl } from '@angular/compiler';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './inventory-management.component.html',
  styleUrls: ['./inventory-management.component.css'],
  providers: [PagerService, DatePipe]

})
export class InventoryManagementComponent implements OnInit {
  loader: string = 'none';
  inverntoryFilters: Filter = new Filter();
  inventoryDetails: InventoryData[] = [];
  mainInventoryDetail: InventoryData[] = [];
  selectedRMHName: any;
  selectedWHLoaction: any;
  selectedLanguage: any;
  selectedCrop: any;
  selectedBrand: any;
  selectedJobType: any;
  selectedState: any;
  roleID: string;
  totalDataCount: any;
  totPage: number;
  pageSetting: number = 10;
  pager: any = {};
  model: any[];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  date = new Date();
  currentDate: string;
  userName: string;
  displayEditPanel: string = 'none';
  isdisabledMaterialDamaged: string = 'false';
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'stateID',
    textField: 'stateName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings2: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobTypeID',
    textField: 'jobTypeName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings3: IDropdownSettings = {
    singleSelection: false,
    idField: 'brandID',
    textField: 'brandName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings4: IDropdownSettings = {
    singleSelection: false,
    idField: 'cropID',
    textField: 'cropName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings5: IDropdownSettings = {
    singleSelection: false,
    idField: 'languageID',
    textField: 'languageName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings6: IDropdownSettings = {
    singleSelection: false,
    idField: 'whLocationID',
    textField: 'whLocationName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings7: IDropdownSettings = {
    singleSelection: false,
    idField: 'rMHCode',
    textField: 'rMHName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  jobNumber: any;
  RMHName : any;
  JobType : any;
  Brand : any;
  Crop : any;
  Language : any;
  State : any;
  MaterialDamaged : any;
  Status : any;
  Quantity : any;
  InventoryID:any;
  FinalStock:any;

  constructor(private router: Router, private inventoryService: InventoryService, private snackBar: MatSnackBarComponent,
    private _pagerService: PagerService, private datepipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userName = localStorage.getItem('mcmt_userName');
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.inventoryFilters();
    this.selectedPaging = '0';
    this.inventoryDetail();
  }

  inventoryDetail() {
    this.loader = 'block';
    this.inventoryService.inventoryDetails(this.selectedRMHName, this.selectedState, this.selectedJobType, this.selectedBrand,
      this.selectedCrop, this.selectedLanguage, this.selectedWHLoaction)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.inventoryDetails = resdata.data.inventory;
          this.mainInventoryDetail = resdata.data.inventory;
          this.model = resdata.data.inventory;
          this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.data.msg);
          this.loader = 'none';
        }
      })
  }

  inventoryFilters() {
    this.loader = 'block';
    this.inventoryService.inventoryFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.inverntoryFilters = resData.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.data.msg);
          this.loader = 'none';
        }
      }
      );
  }

  // damagedMaterial(event) {
  //   this.loader = 'block';
  //   let approvedQuantity: MaterialDamaged[] = [];
  //   this.inventoryDetails.forEach(function (detail) {
  //     var approvedQty = {
  //       InventoryId: detail.inventoryID,
  //       MaterialDamaged: detail.materialDamaged,
  //       Status: detail.status
  //     };
  //     approvedQuantity.push(approvedQty)
  //   });
  //   this.inventoryService.inventoryUpdate(approvedQuantity)
  //     .subscribe((resData: any) => {
  //       if (resData.status == true) {
  //         this.inventoryDetails = resData.data;
  //         this.model = resData.data.inventory;
  //         location.reload();
  //         this.toastr.success(resData.data.msg);
  //         this.loader = 'none';
  //       }
  //       else {
  //         this.toastr.error(resData.data.msg);
  //         this.loader = 'none';
  //       }
  //     }
  //     );
  // }

  excelDownload() {
    this.loader = 'block';
    let selectRmh: any[] = this.selectedRMHName;
    let selectJob: any[] = this.selectedJobType;
    let selectBrand: any[] = this.selectedBrand;
    let selectCrop: any[] = this.selectedCrop;
    let selectLanguage: any[] = this.selectedLanguage;
    let selectWh: any[] = this.selectedWHLoaction;
    let selectState: any[] = this.selectedState;
    let customRmh: string = "";
    let customJob: string = "";
    let customBrand: string = "";
    let customCrop: string = "";
    let customWh: string = "";
    let customLanguage: string = "";
    let customState: string = "";
    if (selectRmh != undefined) {
      selectRmh.forEach(x => {
        if (x.length == 0) {
          customRmh = "";
        }
        else {
          if (customRmh == "") {
            customRmh = x.rMHCode;
          }
          else {
            customRmh = customRmh.concat(",");
            customRmh = customRmh.concat(x.rMHCode);
          }
        }
      })
    }
    if (selectJob != undefined) {
      selectJob.forEach(x => {
        if (x.length == 0) {
          customJob = "";
        }
        else {
          if (customJob == "") {
            customJob = x.jobTypeName;
          }
          else {
            customJob = customJob.concat(",");
            customJob = customJob.concat(x.jobTypeName);
          }
        }
      })
    }
    if (selectBrand != undefined) {
      selectBrand.forEach(x => {
        if (x.length == 0) {
          customBrand = "";
        }
        else {
          if (customBrand == "") {
            customBrand = x.brandName;
          }
          else {
            customBrand = customBrand.concat(",");
            customBrand = customBrand.concat(x.brandName);
          }
        }
      })
    }
    if (selectCrop != undefined) {
      selectCrop.forEach(x => {
        if (x.length == 0) {
          customCrop = "";
        }
        else {
          if (customCrop == "") {
            customCrop = x.cropName;
          }
          else {
            customCrop = customCrop.concat(",");
            customCrop = customCrop.concat(x.cropName);
          }
        }
      })
    }
    if (selectLanguage != undefined) {
      selectLanguage.forEach(x => {
        if (x.length == 0) {
          customLanguage = "";
        }
        else {
          if (customLanguage == "") {
            customLanguage = x.languageName;
          }
          else {
            customLanguage = customLanguage.concat(",");
            customLanguage = customLanguage.concat(x.languageName);
          }
        }
      })
    }
    if (selectWh != undefined) {
      selectWh.forEach(x => {
        if (x.length == 0) {
          customWh = "";
        }
        else {
          if (customWh == "") {
            customWh = x.whLocationName;
          }
          else {
            customWh = customWh.concat(",");
            customWh = customWh.concat(x.whLocationName);
          }
        }
      })
    }
    if (selectState != undefined) {
      selectState.forEach(x => {
        if (x.length == 0) {
          customState = "";
        }
        else {
          if (customState == "") {
            customState = x.stateName;
          }
          else {
            customState = customState.concat(",");
            customState = customState.concat(x.stateName);
          }
        }
      })
    }
    this.inventoryService.downloadInventoryExcel(customRmh, customState, customJob,
      customBrand, customCrop, customLanguage, customWh)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let name = localStorage.getItem('mcmt_userName').split(' ');
          let firstname = name[0];
          let lastName = name[1];
          let excelName = firstname + '_' + lastName + '_Inventory_' + latest_date + '.xlsx';
          saveAs(success, excelName);
          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          this.loader = 'none';
        }
      );
  }

  updateDamagedMaterial(index: any) {
          // if (this.MaterialDamaged == 0 ) {
          //   this.toastr.error('Material Damaged Quantity can not be Zero.');
          //   return false;
          // }
          if (this.MaterialDamaged < 0) {
            this.toastr.error('Material Damaged Quantity can not be less than Zero.');
            return false;
          }
          if (this.MaterialDamaged > this.Quantity) {
            this.toastr.error('Material Damaged Quantity can not be greater than Stock In Quantity.');
            return false;
          }
          if (this.MaterialDamaged > this.FinalStock) {
            this.toastr.error('Material Damaged Quantity can not be greater than Final Stock.');
            return false;
          }
    this.loader = 'block';
    let approvedQuantity: MaterialDamaged[] = [];
    var approvedQty = {
      InventoryId: this.InventoryID,
      JobNumber: this.jobNumber,
      MaterialDamaged: this.MaterialDamaged,
      Status: this.Status
    };
    approvedQuantity.push(approvedQty)

    this.inventoryService.inventoryUpdate(approvedQuantity)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          // this.inventoryDetails = resData.data;
          // this.model = resData.data.inventory;
          // this.setPage(1, this.pageSetting)
          this.toastr.success(resData.message);
          this.loader = 'none';
          this.displayEditPanel= 'none';
          this.inventoryDetail();
        }
        else {
          this.toastr.error(resData.message);
          this.loader = 'none';
        }
      }
      );
  }

  // Start :For Pagination
  setPage(page: number, pageSize: number) {
    // get pager object from service
    if (this.modalSetting == 0) {
      this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
      this.inventoryDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    else {
      if (this.modalSetting == 1) {
        this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
        this.inventoryDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
      else {
        this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
        this.inventoryDetails = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
    }
  }


  filter() {
    let customRmh: any[] = this.selectedRMHName;
    let customBrand: any[] = this.selectedBrand;
    let customJob: any[] = this.selectedJobType;
    let customCrop: any[] = this.selectedCrop;
    let customLanguage: any[] = this.selectedLanguage;
    let customWH: any[] = this.selectedWHLoaction;
    let customState: any[] = this.selectedState;
    let filteredRmh = [];
    let filteredBrand = [];
    let filteredCrop = [];
    let filteredJob = [];
    let filteredLanguage = [];
    let filteredWH = [];
    let filteredState = [];
    let InventoryDetail: InventoryData[] = this.mainInventoryDetail;
    let resultDetail: InventoryData[] = [];
    let resultId = [];
    let filter: boolean = false;
    if (customRmh != undefined && customRmh.length > 0) {
      customRmh.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.rmhid == element.rMHCode) {
            filteredRmh.push(detail.rank);
          }
        })
      });
      resultId = filteredRmh;
      filter = true;
    }
    if (customBrand != undefined && customBrand.length > 0) {
      customBrand.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.brand == element.brandName) {
            filteredBrand.push(detail.rank);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredBrand.includes(x))
        }
      }
      else {
        resultId = filteredBrand;
      }
      filter = true;
    }
    if (customCrop != undefined && customCrop.length > 0) {
      customCrop.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.crop == element.cropName) {
            filteredCrop.push(detail.rank);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredCrop.includes(x))
        }
      }
      else {
        resultId = filteredCrop;
      }
      filter = true;
    }
    if (customJob != undefined && customJob.length > 0) {
      customJob.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.jobType == element.jobTypeName) {
            filteredJob.push(detail.rank);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredJob.includes(x))
        }
      }
      else {
        resultId = filteredJob;
      }
      filter = true;
    }
    if (customLanguage != undefined && customLanguage.length > 0) {
      customLanguage.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.language == element.languageName) {
            filteredLanguage.push(detail.rank);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredLanguage.includes(x))
        }
      }
      else {
        resultId = filteredLanguage;
      }
      filter = true;
    }
    if (customWH != undefined && customWH.length > 0) {
      customWH.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.whLocation == element.whLocationName) {
            filteredWH.push(detail.rank);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredWH.includes(x))
        }
      }
      else {
        resultId = filteredWH;
      }
      filter = true;
    }
    if (customState != undefined && customState.length > 0) {
      customState.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.state == element.stateName) {
            filteredState.push(detail.rank);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredState.includes(x))
        }
      }
      else {
        resultId = filteredState;
      }
      filter = true;
    }
    if (filter == true) {
      resultId.forEach(element => {
        InventoryDetail.forEach(detail => {
          if (detail.rank == element) {
            resultDetail.push(detail);
          }
        })
      })
      this.inventoryDetails = resultDetail;
    }
    else {
      this.inventoryDetails = this.mainInventoryDetail;
    }
  }
  onItemSelect() {

  }
  onSelectAll() {

  }

  viewPanel(JobNumber:any,RMHName:any,JobType:any,Brand:any,Crop:any,Language:any,State:any,MaterialDamaged:any,Status:any,Quantity:any,InventoryID:any,FinalStock:any) {
    this.displayEditPanel = 'block';
    this.jobNumber = JobNumber;
    this.RMHName = RMHName;
    this.JobType = JobType;
    this.Brand = Brand;
    this.Crop = Crop;
    this.Language = Language;
    this.State = State;
    this.MaterialDamaged = MaterialDamaged;
    this.Status = Status;
    this.Quantity = Quantity;
    this.InventoryID = InventoryID;
    this.FinalStock = FinalStock;
    if(this.Status == "Blocked Material")
    {
       this.isdisabledMaterialDamaged = 'true';
    }
    else{
      this.isdisabledMaterialDamaged = 'false';
    }
  }

  inventoryStatuschange()
  {
    if(this.Status == "Blocked Material")
    {
       this.isdisabledMaterialDamaged = 'true';
    }
    else{
      this.isdisabledMaterialDamaged = 'false';
    }
  }

  closeEditPanel() {
    this.displayEditPanel= 'none';
    const body = document. getElementsByTagName('body')[0];
    body.classList.remove('overlay-back');
  }

  onItemSelectState() {
    let customState: any[] = this.selectedState;
    let customRmh = [];
    let customWH = [];
    let finalRMH = [];
    let finalWH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let active: boolean = false;
    let check: boolean = true;
    this.inverntoryFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customWH.length == 0) {
            customWH.push(x);
          }
          else {
            customWH.forEach(y => {
              if (y.stateName != x.stateName) {
                active = true;
              }
            })
            if (active == true) {
              customWH.push(x);
              active = false;
            }
          }
        }
      })
    })
    this.inverntoryFilters.whLocations.forEach(x => {
      customWH.forEach(detail => {
        if (x.whLocationName == detail.whLocationName) {
          if (finalWH.length == 0) {
            finalWH.push(x);
          }
          else {
            finalWH.forEach(y => {
              if (x.whLocationName == y.whLocationName) {
                check = false;
              }
            })
            if (check == true) {
              finalWH.push(x)
            }
            check = true;
          }
        }
      })
    })
    this.inverntoryFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName != x.stateName) {
                active = true;
              }
            })
            if (active == true) {
              customRmh.push(x);
              active = false;
            }
          }
        }
      })
    })
    this.inverntoryFilters.rmh.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (x.rMHCode == y.rMHCode) {
                check = false;
              }
            })
            if (check == true) {
              finalRMH.push(x)
            }
            check = true
          }
        }
      })
    })
    this.inverntoryFilters.languageMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.stateName != x.state) {
                active = true;
              }
            })
            if (active == true) {
              customLanguage.push(x);
              active = false;
            }
          }
        }
      })
    })
    this.inverntoryFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (x.languageName == y.languageName) {
                check = false;
              }
            })
            if (check == true) {
              finalLanguage.push(x)
            }
            check = true
          }
        }
      })
    })
    this.selectedWHLoaction = finalWH;
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }

  onStateDeSelect() {
    this.onItemSelectState()
  }
  ConvertToCurrency(value:any)
  {
    var parts = value.toString().split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
